import React from 'react';
import Intro from './Intro/IntroContainer';
import Detail from './Detail/DetailContainer';
import Info from './Info/InfoContainer';
import QuestionsList from './Questions/QuestionsListContainer';
import Faq from './Faq/FaqContainer';
import Results from './Results/ResultsContainer';


const Scenes = () =>  (

  <div className="scenes">
      <Intro />
      <Detail />
      <QuestionsList />
      <Faq />
      <Info />
      <Results />
  </div>
);

export default Scenes;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Scenes.js
 **/